import { Form, Input } from 'antd';
import generatePicker from 'antd/es/date-picker/generatePicker';

import { dateGenerateConfig } from 'app/components/fields/dateGenerateConfig';
import { endOfDay } from 'app/utils/dayjs';

import { ColorFormItem } from '../ColorFormItem/ColorFormItem';
import { MessageFormItem } from '../MessageFormItem/MessageFormItem';

const DatePicker = generatePicker<Date>(dateGenerateConfig);
const RULES = [{ required: true, message: 'Required' }];

export const EmailEditForm = () => (
  <>
    <ColorFormItem />
    <MessageFormItem />
    <div className="input-row">
      <Form.Item
        name="beneficiaryEmail"
        label="Beneficiary email"
        rules={[
          ...RULES,
          { type: 'email', message: 'Please enter a valid email' },
        ]}
      >
        <Input />
      </Form.Item>
    </div>
    <div className="input-row">
      <Form.Item
        name="billingEmail"
        label="Sender email"
        rules={[
          ...RULES,
          { type: 'email', message: 'Please enter a valid email' },
        ]}
      >
        <Input />
      </Form.Item>
    </div>
    <div className="input-row">
      <Form.Item name="emailSendDate" label="Email Send Date" rules={RULES}>
        <DatePicker
          disabledDate={(current) => current && current < endOfDay(new Date())}
          format="YYYY-MM-DD"
        />
      </Form.Item>
    </div>
  </>
);
